let elementHeight = 60;
let elementWidth = 150;

let normalize = (elements, count) => {

  let minX, minY, maxX, maxY;
  minX = elements.getElementDisplayX(0);
  maxX = minX;
  minY = elements.getElementDisplayY(0);
  maxY = minY;

  for(let i = 0 ; i < count ; i++) //obtém-se os valores extremos
  {
    if (elements.getElementDisplayX(i) < minX)
      minX = elements.getElementDisplayX(i);
    else if (elements.getElementDisplayX(i) > maxX)
      maxX = elements.getElementDisplayX(i);   

    if (elements.getElementDisplayY(i) < minY)
      minY = elements.getElementDisplayY(i);
    else if (elements.getElementDisplayY(i) > maxY)
      maxY = elements.getElementDisplayY(i);
  }

  let deltaX = maxX - minX;
  let deltaY = maxY - minY;

  if (deltaX === 0)
    deltaX = 1;

  if (deltaY === 0)
    deltaY = 1;

  for(let i = 0 ; i < count; i++) 
  {
    elements.setElementDisplayX(i, (elements.getElementDisplayX(i) - minX)/(deltaX) ); 
    elements.setElementDisplayY(i, (elements.getElementDisplayY(i) - minY)/(deltaY) );
  }
};

let getBoundingBox = (x, y, size, name) => { 
            
  let box = [];
  box[0] = x;
  box[1] = y;
  box[2] = elementHeight;
  box[3] = elementWidth;
  
  return box;
};

let repelItem = (i, j, elements) => {

  let force = 0.2;

  // distância entre centros dos itens
  let left1, top1, height1, width1;
  let left2, top2, height2, width2;
  
  let box1 = getBoundingBox(elements.getElementDisplayX(i),elements.getElementDisplayY(i),elements.getElementSize(i),elements.getName(i)); 
  let box2 = getBoundingBox(elements.getElementDisplayX(j),elements.getElementDisplayY(j),elements.getElementSize(j),elements.getName(j));   
  
  left1 = box1[0];
  top1 = box1[1];
  height1 = box1[2];
  width1 = box1[3];
  
  left2 = box2[0];
  top2 = box2[1];
  height2 = box2[2];
  width2 = box2[3];

  let dx = ((left1 + width1/2) - (left2 + width2/2)); 
  let dy = ((top1 + height1/2) - (top2 + height2/2));
  
  // extensão mínima entre duas strings
  let extentsSumX =  15 + (width1 + width2) /2;
  let extentsSumY =  8 + (height1 + height2)/2;

  //calcula quanto deveria ser movimentada em cada direção para escapar da sobreposição. Se o número for negativo, não há sobreposição
  let right =  -dx + extentsSumX;
  let left  =  dx + extentsSumX;
  let down  =  -dy + extentsSumY;
  let up    =  dy + extentsSumY;

  //se já existe um espaço entre eles, não é necessário repelir
  if( !(left < 0 || right < 0 || up < 0 || down < 0))
  {
    //calcula movimentos horizontais e verticais
    let moveX = right;
    if (left < right) 
      moveX = -left;
    let moveY = down; 
    if (up < down)    
      moveY = -up;
    
    //escolhe-se a direção de menor deslocamento, no eixo X ou Y. O movimento no outro eixo será escalado de forma proporcional.
    
    let xy_ratio;
    if (moveY !== 0)
      xy_ratio = Math.abs((moveX/moveY));
    
    else
      xy_ratio = Math.abs(moveX);

    if (xy_ratio < 1)
      moveY*=(xy_ratio*xy_ratio);
    else if (xy_ratio !== 0)
      moveX/=(xy_ratio*xy_ratio);


    let x_displace = moveX*force;
    let y_displace = moveY*force;
      
    elements.setElementDisplayX(i, elements.getElementDisplayX(i) + x_displace);
    elements.setElementDisplayY(i, elements.getElementDisplayY(i) + y_displace);  

    return (Math.abs(x_displace) + Math.abs(y_displace));
  }

  return 0;

};

let repelItems = (mapData, width, height, sizeFactor) => {
  
  width *= sizeFactor;
  height *= sizeFactor;

  let repelIteration = 0;
  let repelSum = 0;

  let count = mapData.getElementsNumber();

  for(let i = 0; i < count ; i++)
  {
    mapData.setElementDisplayX(i, mapData.getElementX(i)*width);
    mapData.setElementDisplayY(i, mapData.getElementY(i)*height);
  }

  do 
  {

    repelSum = 0;
    for(let i = 0 ; i < count ; i++) //de cada elemento para cada elemento, realiza a repulsão das strings
    {

      for(let j = 0; j < count ; j++)
      {
        if (i !== j)
        {

          repelSum += repelItem(i, j, mapData);
        }
      } 
      
    }
    repelIteration++;
  } while (repelIteration < 60 && repelSum > 50);
  
  normalize(mapData, count);

};

module.exports = repelItems;


// WEBPACK FOOTER //
// ./src/js/services/repeller.js